<template>

    <div class="automator" :class="{ 'active': project.is_active }">
        <div class="automator-body">
            <v-button :theme="project.is_active ? 'success' : 'primary'" icon="fas fa-bolt" size="sm" btn-block  @click.native="$store.commit('setModal', 'project-activate')">
                <span v-if="!project.is_active">{{ $t('labels.automate') }}</span>
                <span v-else>{{ $t('labels.automating') }}</span>
            </v-button>
        </div>
        <div v-if="!$store.getters.isClient" class="automator-footer">
            <span><strong :class="{ 'text-danger': asksRemaining === 0 }">{{ asksRemaining | numeral }}</strong> {{ $t('labels.requests_left_this_month') }}</span>
        </div>
    </div>

</template>

<style scoped lang="scss">

    @property --angle {
        syntax: "<angle>";
        initial-value: 0deg;
        inherits: false;
    }

    .automator {
        border: 1px solid $color-rule;
        border-radius: 5px;
        margin: 0 0 10px 0;
        overflow: hidden;
        &.active {
            border: 1px solid transparent;
            background: linear-gradient($color-white, $color-white) padding-box,
                        linear-gradient(var(--angle), $color-rule, $color-rule, $color-success) border-box;
            animation: rotate-border 3s linear infinite;
        }
    }

    .automator-body {
        @include font-medium(13px);
        padding: 10px;
    }

    .automator-footer {
        @include font-regular(12px);
        border-top: 1px solid $color-rule;
        color: $color-text;
        padding: 10px;
        text-align: center;
    }

    @keyframes rotate-border {
        to {
            --angle: 360deg;
        }
    }

</style>

<script>

export default {

    computed: {

        asksRemaining() {
            return this.project.owner_asks_remaining;
        },

    },

}

</script>